// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-control-section {
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px 20px;
  height: 100%;
}
.session-control-section .session-control-heading {
  margin-top: 25px !important;
  margin-bottom: 20px;
}

.session-control-container {
  display: flex;
  background: white;
  flex-direction: column;
  border-radius: 10px;
  height: 570px;
  flex-grow: 1;
}
.session-control-container .session-control-h4 {
  font-size: 14px;
  font-weight: 600;
  background-color: var(--title-container-background);
  margin: 2px;
  padding: 4px 12px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.session-control-container p {
  padding: 13px;
}
.session-control-container .session-options {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  margin: 16px 14px;
}
.session-control-container .session-options .opt1,
.session-control-container .session-options .opt2 {
  height: 144px;
  width: 265px;
  border-radius: 5px;
  background: var(--session-blocks-background-color);
  padding: 20px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  margin-right: 50px;
  color: var(--text-primary-color);
}
.session-control-container .session-options .formEle {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  font-family: "ABBVoice-regular";
  font-size: 16px;
  color: var(--text-primary-color);
}
.session-control-container .session-options .formEle .input-holder {
  margin-right: 15px;
}
.session-control-container .session-options .formEle .label-holder {
  font-size: 14px;
}
.session-control-container .session-timing-container {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  align-items: center;
  margin-left: 15px;
}
.session-control-container .session-timing-container h4 {
  font-family: "ABBVoice-regular";
  font-size: 14px;
  margin: 0 15px 0 0;
  padding: 0;
}
.session-control-container .session-timing-container .session-opts {
  display: flex;
  flex-direction: row;
  background-color: #fff;
  margin-left: 14px;
  border: 1px solid #ebebeb;
  width: fit-content;
  border-radius: 11px;
}
.session-control-container .session-timing-container .session-opts .session-val {
  display: flex;
  flex-direction: row;
}
.session-control-container .session-timing-container .session-opts .session-block {
  display: flex;
  padding: 5px 4px;
  background-color: var(--session-blocks-background-color);
}
.session-control-container .session-timing-container .session-opts .last {
  border-radius: 0 10px 10px 0;
  border-right: 0;
  padding-right: 5px;
}
.session-control-container .session-timing-container .session-opts .first {
  border-radius: 10px 0 0 10px;
  padding-left: 5px;
}
.session-control-container .session-timing-container .session-opts .line {
  display: flex;
  background-color: rgba(0, 0, 0, 0.08);
}
.session-control-container .session-timing-container .session-opts .session_control_btn {
  font-family: "ABBVoice-medium";
  font-size: 16px;
  display: flex;
  padding: 2px 10px;
  background-color: var(--title-container-background);
  color: var(--text-primary-color);
  cursor: pointer;
  border-radius: 8px;
  line-height: 30px;
  border: none;
}
.session-control-container .session-timing-container .session-opts .activeBtn {
  background-color: #36f;
  color: white;
}
.session-control-container .session-timing-container .session-opts .session_control_btn:hover {
  background-color: var(--blocks-hover-background-color);
  color: var(--text-primary-hover-color);
}
.session-control-container .session-timing-container .hours-dd {
  width: 130px;
}
.session-control-container .session-timing-container .css-15g569d-control:hover {
  background: none !important;
}
.session-control-container .session-timing-container .css-1wy0on6 {
  background-color: white !important;
}
.session-control-container .session-timing-container .css-1a681jy:hover {
  background-color: white !important;
}
.session-control-container .session-timing-container .ABB_CommonUX_Icon__root > i.ABB_CommonUX_Icon__icon_abb_16 {
  background-color: white !important;
}

.session-control-buttons {
  display: flex;
  flex-direction: row;
  margin-top: auto;
  margin-left: auto;
  margin-bottom: 14px;
  margin-right: 14px;
  gap: 10px;
}
.session-control-buttons .cancel-button {
  width: 90px;
  height: 20px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 20px;
  border: 1px solid #36f;
  background-color: #fff;
  cursor: pointer;
}
.session-control-buttons .btn-save {
  width: 90px;
  height: 20px;
  font-family: "ABBVoice";
  font-size: 14px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 20px;
  background: #36f;
  border: none;
  box-shadow: none;
  color: white;
  cursor: pointer;
}

.ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__normal {
  background-color: #fff !important;
  border: 2px solid #36f !important;
  color: #1f1f1f !important;
}

.ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize {
  height: 30px !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/session_control.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;AACF;AACE;EACE,2BAAA;EACA,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAII;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kDAAA;EACA,aAAA;EACA,+CAAA;EACA,kBAAA;EACA,gCAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,gCAAA;AAHN;AAKM;EACE,kBAAA;AAHR;AAMM;EACE,eAAA;AAJR;AASE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;AASI;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAPN;AAWI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AATN;AAWM;EACE,aAAA;EACA,mBAAA;AATR;AAYM;EACE,aAAA;EACA,gBAAA;EACA,wDAAA;AAVR;AAaM;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;AAXR;AAcM;EACE,4BAAA;EACA,iBAAA;AAZR;AAeM;EACE,aAAA;EACA,qCAAA;AAbR;AAgBM;EACE,8BAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,mDAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;AAdR;AAiBM;EACE,sBAAA;EACA,YAAA;AAfR;AAkBM;EACE,sDAAA;EACA,sCAAA;AAhBR;AAoBI;EACE,YAAA;AAlBN;AAqBI;EACE,2BAAA;AAnBN;AAsBI;EACE,kCAAA;AApBN;AAuBI;EACE,kCAAA;AArBN;AAwBI;EACE,kCAAA;AAtBN;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAxBF;AA0BE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;AAxBJ;AA2BE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAzBJ;;AA6BA;EACE,iCAAA;EACA,iCAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,uBAAA;AA1BF","sourcesContent":[".session-control-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0 20px 20px 20px;\r\n  height: 100%;\r\n\r\n  .session-control-heading {\r\n    margin-top: 25px !important;\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n.session-control-container {\r\n  display: flex;\r\n  background: white;\r\n  flex-direction: column;\r\n  border-radius: 10px;\r\n  height: 570px;\r\n  flex-grow: 1;\r\n\r\n  .session-control-h4 {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    background-color: var(--title-container-background);\r\n    margin: 2px;\r\n    padding: 4px 12px;\r\n    border-top-right-radius: 8px;\r\n    border-top-left-radius: 8px;\r\n  }\r\n\r\n  p {\r\n    padding: 13px;\r\n  }\r\n\r\n  .session-options {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin-top: 30px;\r\n    margin: 16px 14px;\r\n\r\n    .opt1,\r\n    .opt2 {\r\n      height: 144px;\r\n      width: 265px;\r\n      border-radius: 5px;\r\n      background: var(--session-blocks-background-color);\r\n      padding: 20px;\r\n      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n      margin-right: 50px;\r\n      color: var(--text-primary-color);\r\n    }\r\n\r\n    .formEle {\r\n      display: flex;\r\n      flex-direction: row;\r\n      margin-bottom: 10px;\r\n      font-family: \"ABBVoice-regular\";\r\n      font-size: 16px;\r\n      color: var(--text-primary-color);\r\n\r\n      .input-holder {\r\n        margin-right: 15px;\r\n      }\r\n\r\n      .label-holder {\r\n        font-size: 14px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .session-timing-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin-top: 20px;\r\n    align-items: center;\r\n    margin-left: 15px;\r\n\r\n    h4 {\r\n      font-family: \"ABBVoice-regular\";\r\n      font-size: 14px;\r\n      margin: 0 15px 0 0;\r\n      padding: 0;\r\n\r\n    }\r\n\r\n    .session-opts {\r\n      display: flex;\r\n      flex-direction: row;\r\n      background-color: #fff;\r\n      margin-left: 14px;\r\n      border: 1px solid #ebebeb;\r\n      width: fit-content;\r\n      border-radius: 11px;\r\n\r\n      .session-val {\r\n        display: flex;\r\n        flex-direction: row;\r\n      }\r\n\r\n      .session-block {\r\n        display: flex;\r\n        padding: 5px 4px;\r\n        background-color: var(--session-blocks-background-color);\r\n      }\r\n\r\n      .last {\r\n        border-radius: 0 10px 10px 0;\r\n        border-right: 0;\r\n        padding-right: 5px;\r\n      }\r\n\r\n      .first {\r\n        border-radius: 10px 0 0 10px;\r\n        padding-left: 5px;\r\n      }\r\n\r\n      .line {\r\n        display: flex;\r\n        background-color: rgba(0, 0, 0, 0.08);\r\n      }\r\n\r\n      .session_control_btn {\r\n        font-family: \"ABBVoice-medium\";\r\n        font-size: 16px;\r\n        display: flex;\r\n        padding: 2px 10px;\r\n        background-color: var(--title-container-background);\r\n        color: var(--text-primary-color);\r\n        cursor: pointer;\r\n        border-radius: 8px;\r\n        line-height: 30px;\r\n        border: none;\r\n      }\r\n\r\n      .activeBtn {\r\n        background-color: #36f;\r\n        color: white;\r\n      }\r\n\r\n      .session_control_btn:hover {\r\n        background-color: var(--blocks-hover-background-color);\r\n        color: var(--text-primary-hover-color);\r\n      }\r\n    }\r\n\r\n    .hours-dd {\r\n      width: 130px;\r\n    }\r\n\r\n    .css-15g569d-control:hover {\r\n      background: none !important;\r\n    }\r\n\r\n    .css-1wy0on6 {\r\n      background-color: white !important;\r\n    }\r\n\r\n    .css-1a681jy:hover {\r\n      background-color: white !important;\r\n    }\r\n\r\n    .ABB_CommonUX_Icon__root>i.ABB_CommonUX_Icon__icon_abb_16 {\r\n      background-color: white !important;\r\n    }\r\n  }\r\n}\r\n\r\n.session-control-buttons {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-top: auto;\r\n  margin-left: auto;\r\n  margin-bottom: 14px;\r\n  margin-right: 14px;\r\n  gap: 10px;\r\n\r\n  .cancel-button {\r\n    width: 90px;\r\n    height: 20px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n    border-radius: 20px;\r\n    border: 1px solid #36f;\r\n    background-color: #fff;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .btn-save {\r\n    width: 90px;\r\n    height: 20px;\r\n    font-family: \"ABBVoice\";\r\n    font-size: 14px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n    border-radius: 20px;\r\n    background: #36f;\r\n    border: none;\r\n    box-shadow: none;\r\n    color: white;\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__normal {\r\n  background-color: #fff !important;\r\n  border: 2px solid #36f !important;\r\n  color: #1f1f1f !important;\r\n}\r\n\r\n.ABB_CommonUX_Button__root.ABB_CommonUX_Button__mediumSize {\r\n  height: 30px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
